module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-authors"
    }
  }, [_c('h1', [_vm._v("About the Authors")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.20472in",
      "height": "2.75591in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Lorraine Flower")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("With over 40 years in leadership and global business across multiple sectors and in senior leadership and consulting roles, Lorraine’s knowledge and understanding of the business world is extensive. Her belief in individual and organisational power for good fuels her deep commitment and vocational drive.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Passionate about developing and exploring conscious leadership, Lorraine believes that business leaders are key players in transforming the well-being of the planet and humanity as a whole.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.13935in",
      "height": "2.67419in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Trudy Worth")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Ex-journalist, ex-PR, Trudy cut her leadership teeth heading teams in a 20-year-plus career in PR consultancy and working with senior teams in client organisations before a career change to organisation and leadership development. She’s passionate about the power of business and leaders to create a better world, enriching all, not just a shareholding few.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Her work is dedicated to helping leaders at all levels develop greater consciousness of the world around them to make a positive difference inside their organisation and the world it serves.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0